import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiEmployeeShort } from "@/types/employees/employee.types.ts";
import { LinkTo, Stack, Text, Tooltip, TooltipContent, TooltipTrigger } from "@skailer-com/uikit";
import React from "react";
import { useTranslation } from "react-i18next";

type EmployeesListInlineProps = {
  employees?: ApiEmployeeShort[];
  employee?: ApiEmployeeShort;
  enableLink?: boolean;
};

export const EmployeeInline = ({
  employees,
  employee,
  enableLink = false,
}: EmployeesListInlineProps) => {
  const { renderEmployeeName } = useFormatter();
  const { t } = useTranslation();
  if (!employee && !employees) return null;

  let employeesList: ApiEmployeeShort[] = [];
  if (employees) employeesList = employees;
  if (employee) employeesList = [employee];

  if (employeesList.length <= 2)
    return (
      <Text>
        {employeesList
          .map((employee) => (
            <LinkTo
              key={employee.id}
              to={`/employees/${employee.id}`}
              className="text-secondary"
              variant="secondary"
              target={"_blank"}
              disabled={employee.is_archived || !enableLink}
            >
              {renderEmployeeName(employee)}
            </LinkTo>
          ))
          .reduce<React.ReactNode[]>(
            (acc, curr, i, arr) => (i === arr.length - 1 ? [...acc, curr] : [...acc, curr, ", "]),
            []
          )}
      </Text>
    );

  return (
    <Text>
      <LinkTo
        to={`/employees/${employeesList[0].id}`}
        className={"text-secondary"}
        variant={"secondary"}
        target={"_blank"}
        disabled={employeesList[0].is_archived || !enableLink}
      >
        {renderEmployeeName(employeesList[0])}
      </LinkTo>
      {", "}
      <Tooltip>
        <TooltipTrigger>
          <Text
            className={"text-secondary"}
          >{`+${t("plurals:plural_others", { count: employeesList.length - 1 })}`}</Text>
        </TooltipTrigger>
        <TooltipContent>
          <Stack>
            {employeesList.slice(1).map((employee) => (
              <LinkTo
                key={`employee-tooltip-${employee.id}`}
                to={`/employees/${employee.id}`}
                className={"text-light"}
                variant={"secondary"}
                target={"_blank"}
                disabled={employee.is_archived || !enableLink}
              >
                {renderEmployeeName(employee)}
              </LinkTo>
            ))}
          </Stack>
        </TooltipContent>
      </Tooltip>
    </Text>
  );
};
